import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import authenticate from '../../layouts/authenticateHOC'
import * as actions from '../../layouts/LoggedIn/actions'
import { shouldRedirectUserToLogin } from '../../layouts/LoggedIn/actions'
import Paper from 'material-ui/Paper'
import ReactMarkdown from 'react-markdown'
import { Tab, Tabs } from 'material-ui/Tabs'
import { checkAdmin, database, checkJapanese } from '../../lib'

const newsFVliteRef = database.ref(`/contents/FVlite_news`)

class News extends Component {

  constructor(props) {
    super(props)
    this.state = {
      body: ''
    }
  }

  Save() {
    newsFVliteRef.update({ body: this.state.body })
    let warning = checkJapanese() ? '保存しました。' : 'Saved.';
    alert(warning)
  }

  async componentDidMount() {
    const sessionToken = sessionStorage.getItem('authToken')
    const localToken = localStorage.getItem('authToken')
    if (sessionToken === null && localToken === null) {
      this.props.history.push('/login')
    }

    let newsObj

    if (this.props.location.pathname === '/edit_news') {
      checkAdmin()
    }
    newsObj = (await newsFVliteRef.once('value')).val()

    if (newsObj) {
      this.setState({ body: newsObj.body })
    }
  }

  render() {
    return (
      <div className={this.props.view === 'desktop' ? "h-100 w-100 flex items-center pt2 pr7 justify-center" : "h-100 w-100 flex items-center justify-center"}>
        <Tabs
          contentContainerClassName={`pt1 pb1`}
          inkBarStyle={{ background: '#29B87A' }}
          tabItemContainerStyle={{
            backgroundColor: '#FFFFFF',
            color: '#29B87A',
            borderBottom: '1px solid #d9d9d9',
            boxShadow: '0 8px 3px -5px #d9d9d9'
          }}
        >
          <Tab
            onActive={null}
            buttonStyle={{ color: '#29B87A' }}
            label={'ニュース(News)'}>
            <Paper
              rounded={false}
              style={{
                backgroundColor: '#FAFAFA',
                height: '100%'
              }}
              className={this.props.view === 'desktop' ? 'news-paper' : ''}
              >
              <div className="news-data" style={{
                overflow: 'auto',
                height: '80vh',
                overflowY: 'auto'
              }}>
                <ReactMarkdown source={this.state.body} />
              </div>
            </Paper>
          </Tab>
          {this.props.location.pathname === '/edit_news' && <Tab
            onActive={null}
            buttonStyle={{ color: '#29B87A' }}
            label={'編集(Edit)'}>
            <table>
              <tr>
                <textarea
                  style={{
                    width: '45vw',
                    backgroundColor: '#FAFAFA',
                    height: '30vw',
                    float: 'left',
                    marginRight: '10',
                    listStyle: 'none'
                  }}
                  value={this.state.body} onChange={(e) => this.setState({ body: e.target.value })}
                >
                </textarea>
              </tr>
              <tr>
                <button
                  style={{
                    float: 'left',
                    listStyle: 'none'
                  }}
                  onClick={() => this.Save()}>
                  更新(Update)
                </button>
              </tr>
            </table>
          </Tab>
          }
        </Tabs>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    redirectToLogin: state.loginLayout.redirectToLogin,
    tokenVerified: state.loginLayout.tokenVerified,
    isLoggedIn: state.login.isLoggedIn,
    open: state.loginLayout.open,
    view: state.loginLayout.view,
    ...ownProps
  }
}
const mapDispatchToProps = dispatch => ({
  returnUserIfUserExists: token =>
    dispatch(actions.returnUserIfUserExists(token)),
  checkValidity: token => dispatch(actions.checkValidity(token)),
  checkTokenOnPathChange: token =>
    dispatch(actions.checkTokenOnPathChange(token)),
  shouldRedirectUserToLogin: bool => dispatch(shouldRedirectUserToLogin(bool)),
})

let NewsP = window.location.pathname === '/edit_news' ? connect(mapStateToProps, mapDispatchToProps)(withRouter(authenticate(News))) : connect(mapStateToProps, mapDispatchToProps)(News)
export default NewsP



// WEBPACK FOOTER //
// src/routes/News/index.js